import React from "react";
import Input from "../../core/input";
import { InputConfig } from "../../core/types";

/**
 * @name RawPhoneNumberField
 * @description This field is used in PhoneNumberWrapper component for input numbers
 * @param onChange
 * @param props
 * @constructor
 */
export default function RawPhoneNumberField({ onChange, ...props }: InputConfig) {
  const [inputValue, setInputValue] = React.useState(props.value);

  const onChangeHandler = React.useCallback(
    e => {
      const val = e.target.value;
      setInputValue(val);
      onChange?.(val);
    },
    [onChange]
  );

  return (
    <Input
      innerRef={props.innerRef}
      name={props.name}
      value={inputValue}
      onBlur={props.onBlur}
      onChange={onChangeHandler}
      disabled={props.disabled}
      placeholder={props.placeholder}
      hasError={props.hasError}
      autoComplete={props.autoComplete}
      autoFocus={props.autoFocus}
    />
  );
}
